export default __webpack_public_path__ + "static/media/Microsoft1.a97ef361.png";